import React, { useEffect, useState } from 'react';
import { Drawer, useMediaQuery } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

/** One permission-filtered navigation tree, with MUI focus/escape/backdrop handling on phones. */
export default function ResponsiveNavigation({ children, mobileOnly = false }: {
  children: React.ReactNode;
  mobileOnly?: boolean;
}) {
  const mobile = useMediaQuery('(max-width: 960px)');
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.key, mobile]);

  if (!mobile) return mobileOnly ? null : <>{children}</>;
  return (
    <>
      <button type="button" className="admin-menu-toggle" aria-label="Open navigation"
        aria-expanded={open} aria-controls={open ? 'admin-mobile-navigation' : undefined}
        onClick={() => setOpen(true)}>
        <span aria-hidden="true">☰</span>
      </button>
      <Drawer open={open} onClose={() => setOpen(false)}
        PaperProps={{ className: 'admin-mobile-drawer', id: 'admin-mobile-navigation' }}>
        <button type="button" className="admin-menu-close" aria-label="Close navigation"
          onClick={() => setOpen(false)}>Close <span aria-hidden="true">×</span></button>
        <div onClick={(event) => {
          if ((event.target as HTMLElement).closest('a')) setOpen(false);
        }}>{children}</div>
      </Drawer>
    </>
  );
}
